import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  SavedCardDetails,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperAccountSettingsSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  UserNav,
  SecondaryButton,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './StripeSubscriptions.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
import Grid from '@material-ui/core/Grid';
import SubscriptionCard from './SubscriptionCard';
import { post } from '../../util/api';

const sharetribeSdk = require('sharetribe-flex-sdk');

const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

const { UUID, LatLng } = sdkTypes;

const Account = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [stripeCustomerId, setStripeCustomerId] = useState(false);
  const [showAll, setShowAll] = useState(true);

  useEffect(() => {
    return sdk.currentUser
      .show({
        include: ['stripeAccount', 'stripeCustomer'],
      })
      .then(resp => {
        const hasCustomerId = resp.data.data.attributes.profile.protectedData?.stripeCustomerId;
        setStripeCustomerId(hasCustomerId);

        if (hasCustomerId) {
          const requestOptions = {
            stripeCustomerId: hasCustomerId,
          };

          post('/api/subscriptions', requestOptions)
            .then(resp => {
              const subscriptions = resp.subscriptions.data;

              setSubscriptions(subscriptions);
            })
            .catch(error => console.log(error));
        } else {
          setSubscriptions([]);
        }
      })
      .catch(e => console.log(e));
  }, []);

  if (!subscriptions) {
    return '';
  }

  const title = 'Subscriptions';

  const dummySubscriptionsForTests = {
    object: 'list',
    data: [
      {
        id: 'sub_K1WxqWCONG4RtC',
        object: 'subscription',
        application_fee_percent: null,
        automatic_tax: {
          enabled: false,
        },
        billing_cycle_anchor: 1628736230,
        billing_thresholds: null,
        cancel_at: null,
        cancel_at_period_end: false,
        canceled_at: null,
        collection_method: 'charge_automatically',
        created: 1628736230,
        current_period_end: 1628822630,
        current_period_start: 1628736230,
        customer: 'cus_K1NqORHnaeipKn',
        days_until_due: null,
        default_payment_method: null,
        default_source: null,
        default_tax_rates: [],
        discount: null,
        ended_at: null,
        items: {
          object: 'list',
          data: [
            {
              id: 'si_K1WxjWqsqDGiCi',
              object: 'subscription_item',
              billing_thresholds: null,
              created: 1628736231,
              metadata: {},
              plan: {
                id: 'price_1JN9rJHuyiqLZdHE9qViTGa2',
                object: 'plan',
                active: true,
                aggregate_usage: null,
                amount: 500,
                amount_decimal: '500',
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                interval: 'day',
                interval_count: 1,
                livemode: false,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                tiers_mode: null,
                transform_usage: null,
                trial_period_days: null,
                usage_type: 'licensed',
              },
              price: {
                id: 'price_1JN9rJHuyiqLZdHE9qViTGa2',
                object: 'price',
                active: true,
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                livemode: false,
                lookup_key: null,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                recurring: {
                  aggregate_usage: null,
                  interval: 'day',
                  interval_count: 1,
                  trial_period_days: null,
                  usage_type: 'licensed',
                },
                tax_behavior: 'unspecified',
                tiers_mode: null,
                transform_quantity: null,
                type: 'recurring',
                unit_amount: 500,
                unit_amount_decimal: '500',
              },
              quantity: 1,
              subscription: 'sub_K1WxqWCONG4RtC',
              tax_rates: [],
            },
          ],
          has_more: false,
          total_count: 1,
          url: '/v1/subscription_items?subscription=sub_K1WxqWCONG4RtC',
        },
        latest_invoice: 'in_1JNTtaHuyiqLZdHE64idUfPS',
        livemode: false,
        metadata: {},
        next_pending_invoice_item_invoice: null,
        pause_collection: null,
        payment_settings: {
          payment_method_options: null,
          payment_method_types: null,
        },
        pending_invoice_item_interval: null,
        pending_setup_intent: null,
        pending_update: null,
        plan: {
          id: 'price_1JN9rJHuyiqLZdHE9qViTGa2',
          object: 'plan',
          active: true,
          aggregate_usage: null,
          amount: 500,
          amount_decimal: '500',
          billing_scheme: 'per_unit',
          created: 1628659209,
          currency: 'eur',
          interval: 'day',
          interval_count: 1,
          livemode: false,
          metadata: {},
          nickname: null,
          product: 'prod_K1CFeYf1PtsnjD',
          tiers_mode: null,
          transform_usage: null,
          trial_period_days: null,
          usage_type: 'licensed',
        },
        quantity: 1,
        schedule: null,
        start_date: 1628736230,
        status: 'active',
        transfer_data: null,
        trial_end: null,
        trial_start: null,
      },
      {
        id: 'sub_K1PLojYZUM7zGf',
        object: 'subscription',
        application_fee_percent: null,
        automatic_tax: {
          enabled: false,
        },
        billing_cycle_anchor: 1628707915,
        billing_thresholds: null,
        cancel_at: null,
        cancel_at_period_end: false,
        canceled_at: null,
        collection_method: 'charge_automatically',
        created: 1628707915,
        current_period_end: 1628794315,
        current_period_start: 1628707915,
        customer: 'cus_K1NqORHnaeipKn',
        days_until_due: null,
        default_payment_method: null,
        default_source: null,
        default_tax_rates: [],
        discount: null,
        ended_at: null,
        items: {
          object: 'list',
          data: [
            {
              id: 'si_K1PLoSbtMuWMYs',
              object: 'subscription_item',
              billing_thresholds: null,
              created: 1628707916,
              metadata: {},
              plan: {
                id: 'price_1JN9rJHuyiqLZdHE9qViTGa2',
                object: 'plan',
                active: true,
                aggregate_usage: null,
                amount: 500,
                amount_decimal: '500',
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                interval: 'day',
                interval_count: 1,
                livemode: false,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                tiers_mode: null,
                transform_usage: null,
                trial_period_days: null,
                usage_type: 'licensed',
              },
              price: {
                id: 'price_1JN9rJHuyiqLZdHE9qViTGa2',
                object: 'price',
                active: true,
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                livemode: false,
                lookup_key: null,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                recurring: {
                  aggregate_usage: null,
                  interval: 'day',
                  interval_count: 1,
                  trial_period_days: null,
                  usage_type: 'licensed',
                },
                tax_behavior: 'unspecified',
                tiers_mode: null,
                transform_quantity: null,
                type: 'recurring',
                unit_amount: 500,
                unit_amount_decimal: '500',
              },
              quantity: 1,
              subscription: 'sub_K1PLojYZUM7zGf',
              tax_rates: [],
            },
          ],
          has_more: false,
          total_count: 1,
          url: '/v1/subscription_items?subscription=sub_K1PLojYZUM7zGf',
        },
        latest_invoice: 'in_1JNMWtHuyiqLZdHELzbEaShp',
        livemode: false,
        metadata: {},
        next_pending_invoice_item_invoice: null,
        pause_collection: null,
        payment_settings: {
          payment_method_options: null,
          payment_method_types: null,
        },
        pending_invoice_item_interval: null,
        pending_setup_intent: null,
        pending_update: null,
        plan: {
          id: 'price_1JN9rJHuyiqLZdHE9qViTGa2',
          object: 'plan',
          active: true,
          aggregate_usage: null,
          amount: 500,
          amount_decimal: '500',
          billing_scheme: 'per_unit',
          created: 1628659209,
          currency: 'eur',
          interval: 'day',
          interval_count: 1,
          livemode: false,
          metadata: {},
          nickname: null,
          product: 'prod_K1CFeYf1PtsnjD',
          tiers_mode: null,
          transform_usage: null,
          trial_period_days: null,
          usage_type: 'licensed',
        },
        quantity: 1,
        schedule: null,
        start_date: 1628707915,
        status: 'active',
        transfer_data: null,
        trial_end: null,
        trial_start: null,
      },
      {
        id: 'sub_K1OFk8ugiCRfNZ',
        object: 'subscription',
        application_fee_percent: null,
        automatic_tax: {
          enabled: false,
        },
        billing_cycle_anchor: 1628703800,
        billing_thresholds: null,
        cancel_at: null,
        cancel_at_period_end: false,
        canceled_at: 1628736142,
        collection_method: 'charge_automatically',
        created: 1628703800,
        current_period_end: 1628790200,
        current_period_start: 1628703800,
        customer: 'cus_K1NqORHnaeipKn',
        days_until_due: null,
        default_payment_method: null,
        default_source: null,
        default_tax_rates: [],
        discount: null,
        ended_at: 1628736142,
        items: {
          object: 'list',
          data: [
            {
              id: 'si_K1OFuCxqKqZ38m',
              object: 'subscription_item',
              billing_thresholds: null,
              created: 1628703800,
              metadata: {},
              plan: {
                id: 'price_1JN9rJHuyiqLZdHEWCDYEUrC',
                object: 'plan',
                active: true,
                aggregate_usage: null,
                amount: 1000,
                amount_decimal: '1000',
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                interval: 'day',
                interval_count: 1,
                livemode: false,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                tiers_mode: null,
                transform_usage: null,
                trial_period_days: null,
                usage_type: 'licensed',
              },
              price: {
                id: 'price_1JN9rJHuyiqLZdHEWCDYEUrC',
                object: 'price',
                active: true,
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                livemode: false,
                lookup_key: null,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                recurring: {
                  aggregate_usage: null,
                  interval: 'day',
                  interval_count: 1,
                  trial_period_days: null,
                  usage_type: 'licensed',
                },
                tax_behavior: 'unspecified',
                tiers_mode: null,
                transform_quantity: null,
                type: 'recurring',
                unit_amount: 1000,
                unit_amount_decimal: '1000',
              },
              quantity: 1,
              subscription: 'sub_K1OFk8ugiCRfNZ',
              tax_rates: [],
            },
          ],
          has_more: false,
          total_count: 1,
          url: '/v1/subscription_items?subscription=sub_K1OFk8ugiCRfNZ',
        },
        latest_invoice: 'in_1JNLSWHuyiqLZdHEgXTb55OM',
        livemode: false,
        metadata: {},
        next_pending_invoice_item_invoice: null,
        pause_collection: null,
        payment_settings: {
          payment_method_options: null,
          payment_method_types: null,
        },
        pending_invoice_item_interval: null,
        pending_setup_intent: null,
        pending_update: null,
        plan: {
          id: 'price_1JN9rJHuyiqLZdHEWCDYEUrC',
          object: 'plan',
          active: true,
          aggregate_usage: null,
          amount: 1000,
          amount_decimal: '1000',
          billing_scheme: 'per_unit',
          created: 1628659209,
          currency: 'eur',
          interval: 'day',
          interval_count: 1,
          livemode: false,
          metadata: {},
          nickname: null,
          product: 'prod_K1CFeYf1PtsnjD',
          tiers_mode: null,
          transform_usage: null,
          trial_period_days: null,
          usage_type: 'licensed',
        },
        quantity: 1,
        schedule: null,
        start_date: 1628703800,
        status: 'canceled',
        transfer_data: null,
        trial_end: null,
        trial_start: null,
      },
      {
        id: 'sub_K1Nq9CAuUbjGMf',
        object: 'subscription',
        application_fee_percent: null,
        automatic_tax: {
          enabled: false,
        },
        billing_cycle_anchor: 1628702325,
        billing_thresholds: null,
        cancel_at: null,
        cancel_at_period_end: false,
        canceled_at: null,
        collection_method: 'charge_automatically',
        created: 1628702325,
        current_period_end: 1628788725,
        current_period_start: 1628702325,
        customer: 'cus_K1NqORHnaeipKn',
        days_until_due: null,
        default_payment_method: null,
        default_source: null,
        default_tax_rates: [],
        discount: null,
        ended_at: null,
        items: {
          object: 'list',
          data: [
            {
              id: 'si_K1NqLOFpk6viZX',
              object: 'subscription_item',
              billing_thresholds: null,
              created: 1628702326,
              metadata: {},
              plan: {
                id: 'price_1JN9rJHuyiqLZdHEWCDYEUrC',
                object: 'plan',
                active: true,
                aggregate_usage: null,
                amount: 1000,
                amount_decimal: '1000',
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                interval: 'day',
                interval_count: 1,
                livemode: false,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                tiers_mode: null,
                transform_usage: null,
                trial_period_days: null,
                usage_type: 'licensed',
              },
              price: {
                id: 'price_1JN9rJHuyiqLZdHEWCDYEUrC',
                object: 'price',
                active: true,
                billing_scheme: 'per_unit',
                created: 1628659209,
                currency: 'eur',
                livemode: false,
                lookup_key: null,
                metadata: {},
                nickname: null,
                product: 'prod_K1CFeYf1PtsnjD',
                recurring: {
                  aggregate_usage: null,
                  interval: 'day',
                  interval_count: 1,
                  trial_period_days: null,
                  usage_type: 'licensed',
                },
                tax_behavior: 'unspecified',
                tiers_mode: null,
                transform_quantity: null,
                type: 'recurring',
                unit_amount: 1000,
                unit_amount_decimal: '1000',
              },
              quantity: 1,
              subscription: 'sub_K1Nq9CAuUbjGMf',
              tax_rates: [],
            },
          ],
          has_more: false,
          total_count: 1,
          url: '/v1/subscription_items?subscription=sub_K1Nq9CAuUbjGMf',
        },
        latest_invoice: 'in_1JNL4jHuyiqLZdHEGmGNS8np',
        livemode: false,
        metadata: {},
        next_pending_invoice_item_invoice: null,
        pause_collection: null,
        payment_settings: {
          payment_method_options: null,
          payment_method_types: null,
        },
        pending_invoice_item_interval: null,
        pending_setup_intent: null,
        pending_update: null,
        plan: {
          id: 'price_1JN9rJHuyiqLZdHEWCDYEUrC',
          object: 'plan',
          active: true,
          aggregate_usage: null,
          amount: 1000,
          amount_decimal: '1000',
          billing_scheme: 'per_unit',
          created: 1628659209,
          currency: 'eur',
          interval: 'day',
          interval_count: 1,
          livemode: false,
          metadata: {},
          nickname: null,
          product: 'prod_K1CFeYf1PtsnjD',
          tiers_mode: null,
          transform_usage: null,
          trial_period_days: null,
          usage_type: 'licensed',
        },
        quantity: 1,
        schedule: null,
        start_date: 1628702325,
        status: 'active',
        transfer_data: null,
        trial_end: null,
        trial_start: null,
      },
    ],
    has_more: false,
    url: '/v1/subscriptions',
  };

  const handleSort = () => {
    setShowAll(!showAll);
  };

  const hasAnyActiveSubscription = subscriptions
    ? subscriptions.length === 0
      ? false
      : subscriptions.find(sub => {
          return sub.status === 'active';
        })
    : false;

  console.log(subscriptions);
  return (
    <Page title={title}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="StripeAccountSubscriptionsPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
          <UserNav selectedPageName="StripeAccountSubscriptionsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperAccountSettingsSideNav currentTab="StripeAccountSubscriptionsPage" />
        <LayoutWrapperMain>
          {stripeCustomerId ? (
            <div className={css.content}>
              <Grid container xs={12}>
                <Grid container item xs={12}>
                  <Grid container item xs={12}>
                    <h1 className={css.title}>Abonnements</h1>
                  </Grid>
                  {/* <Grid container item xs={12}>
                    <div className={css.buttonsWrapper}>
                      
                        <a className={css.addSubscriptionButton} href="/prices">
                          <SecondaryButton className={css.addButton}>Add a subscription</SecondaryButton>
                          </a>
                         
                    </div>
                </Grid> */}
                </Grid>

                <Grid container item xs={12}>
                  <div id="subscriptions" className={css.subsriptionsWrapper}>
                    {subscriptions.map(s => {
                      if (s.status !== 'incomplete' && s.status !== 'incomplete_expired') {
                        return (
                          <Grid container item xs={12}>
                            <div className={css.subscriptionCard}>
                              <SubscriptionCard key={s.id} subscription={s} />
                            </div>
                          </Grid>
                        );
                      }
                    })}
                  </div>
                  {hasAnyActiveSubscription ? null : <p>Vous n'avez pas d'abonnement actif</p>}
                </Grid>
              </Grid>
            </div>
          ) : (
            <div className={css.content}>
              <h2>
                Pour utiliser les abonnements, veuillez d'abord ajouter un mode de paiement{' '}
                <a
                  href={
                    typeof window !== 'undefined'
                      ? `${window.location.origin}/account/payment-methods`
                      : ''
                  }
                >
                  ici.
                </a>
              </h2>
            </div>
          )}
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

export default withRouter(Account);
